import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import {
  numberWithComma,
  formatDateWithoutTime,
  currentDateTimeThaiformat,
  getMenuTypeName,
} from 'helpers/format'
import { Col, Divider, Row, Space } from 'antd'
import PdfCompanyInfo from 'Pages/Purchase/components/PdfCompanyInfo'
import { PdfPrintFormat, PdfPrintLiteFormat } from 'Components/form'
import { ThaiBaht } from 'thai-baht-text-ts'
import { SupplierBillData, SupplierBillItem } from 'Store/supplier-bill/types'
import { ReturnData } from 'Store/return-order/types'
import { menuReturnPaymentTypes } from 'helpers/constanst'

type Props = {
  detail?: SupplierBillData
  isLite?: boolean
}

const BillingNotePDF: React.FunctionComponent<Props> = props => {
  const { detail, isLite = false } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderInfoItem = (title: any, value: any, justify: 'start' | 'end' = 'start') => {
    return (
      <Row gutter={[8, 8]} justify={justify}>
        <Col>
          <Space wrap={true}>
            <InfoTitle>
              {title} : {value || '-'}
            </InfoTitle>
          </Space>
        </Col>
      </Row>
    )
  }

  const renderCustomerInfo = () => {
    return (
      <div>
        {renderInfoItem('ชื่อลูกค้า/คู่ค้า', detail?.name)}
        {renderInfoItem('ที่อยู่', detail?.address)}
        {renderInfoItem('เบอร์โทรศัพท์', detail?.mobile)}
        {renderInfoItem('อีเมล', detail?.email)}
      </div>
    )
  }

  const renderPurchaseInfo = () => {
    return (
      <div>
        {renderInfoItem('เลขที่ใบวางบิล', detail?.billing_note_no, 'end')}
        {renderInfoItem('วันที่', formatDateWithoutTime(detail?.created_at || ''), 'end')}
        {renderInfoItem('วันที่พิมพ์', currentDateTimeThaiformat(), 'end')}
      </div>
    )
  }

  const summaryFooter = (
    <Row justify="space-between" align="bottom">
      <Col span={12}>
        <InfoTitle style={{ textAlign: 'left' }}>
          รวมเงินทั้งสิ้น (ตัวอักษร) {ThaiBaht(detail?.total_remain || 0)}
        </InfoTitle>
      </Col>
      <Col span={8}>
        <Row justify="space-between">
          <Col>
            <InfoTitle>รวม รายการออกใบวางบิลทั้งหมด</InfoTitle>
          </Col>
          <Col>
            <InfoTitle>
              {numberWithComma((detail?.total_amount || 0) - (detail?.total_paid || 0), true)} บาท
            </InfoTitle>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col>
            <InfoTitle>หัก รายการคืนสินค้า/ลดหนี้</InfoTitle>
          </Col>
          <Col>
            <InfoTitle>{numberWithComma(detail?.total_void || 0, true)} บาท</InfoTitle>
          </Col>
        </Row>
        <Divider style={{ margin: '5px 0', color: '#000' }} />
        <Row justify="space-between">
          <Col>
            <InfoTitle>รวมเงินทั้งสิ้น</InfoTitle>
          </Col>
          <Col>
            <InfoTitle>{numberWithComma(detail?.total_remain || 0, true)} บาท</InfoTitle>
          </Col>
        </Row>
      </Col>
    </Row>
  )

  const moreFooter = (
    <Row justify="start">
      <Col span={12}>
        <InfoTitle style={{ textAlign: 'left' }}>หมายเหตุ : {detail?.remark || '-'}</InfoTitle>
      </Col>
    </Row>
  )

  const tableHeader = (
    <>
      <thead>
        <tr>
          <th colSpan={7} className="title">
            รายการออกใบวางบิล
          </th>
        </tr>
        <tr>
          <th>ลำดับ</th>
          <th className="left">เลขที่สั่งซื้อ</th>
          {/* <th className="left">เลขที่ใบเสนอราคา</th> */}
          <th className="left">วันที่สั่งซื้อ</th>
          <th className="left">วันที่ครบกำหนดชำระ</th>
          {/* <th className="left">วันที่จัดส่ง</th> */}
          <th className="right">ยอดสั่งซื้อ</th>
          <th className="right">ยอดชำระ</th>
          <th className="right">ยอดค้างชำระ</th>
        </tr>
      </thead>
    </>
  )

  const tableBody = (
    <tbody>
      {detail?.items &&
        detail.items.map((item: SupplierBillItem, index: number) => {
          return (
            <tr key={index}>
              <td>{renderInfo(index + 1)}</td>
              <td className="left">{renderInfo(item?.sale_order_no || '-')}</td>
              {/* <td className="left">{renderInfo(item?.quotation_no || '-')}</td> */}
              <td className="left">{renderInfo(formatDateWithoutTime(item?.order_date || '-'))}</td>
              <td className="left">
                {renderInfo(item?.expiry_dt ? formatDateWithoutTime(item?.expiry_dt || '-') : '-')}
              </td>
              {/* <td className="left">{renderInfo(formatDateWithoutTime(item?.delivered_date) || '-')}</td> */}
              <td className="right">{renderInfo(numberWithComma(item?.total_amount || 0, true))}</td>
              <td className="right">{renderInfo(numberWithComma(item?.total_paid || 0, true))}</td>
              <td className="right">{renderInfo(numberWithComma(item?.total_remain || 0, true))}</td>
            </tr>
          )
        })}
    </tbody>
  )

  const tableHeader2 = (
    <>
      <thead>
        <tr>
          <th colSpan={7} className="title">
            รายการคืนสินค้า/ลดหนี้
          </th>
        </tr>
        <tr>
          <th>ลำดับ</th>
          <th className="left">เลขที่สั่งซื้อ</th>
          <th className="left">วันที่รับคืนสินค้า</th>
          {/* <th className="left">เลขที่ใบเสนอราคา</th> */}
          {/* <th className="left">ช่องทางการคืนเงิน</th>
          <th className="left">รับคืนโดย</th> */}
          <th className="right" colSpan={4}>
            ยอดลดหนี้สุทธิ
          </th>
        </tr>
      </thead>
    </>
  )

  const tableBody2 = (
    <tbody>
      {detail?.void_items &&
        detail.void_items.map((item: SupplierBillItem, index: number) => {
          return (
            <tr key={index}>
              <td>{renderInfo(index + 1)}</td>
              <td className="left">{renderInfo(item?.sale_order_no || '-')}</td>
              <td className="left">{renderInfo(formatDateWithoutTime(item?.order_date || '-'))}</td>
              {/* <td className="left">
                {renderInfo(getMenuTypeName(menuReturnPaymentTypes, item?.return_type || ''))}
              </td>
              <td className="left">{renderInfo(item?.officer || '-')}</td> */}
              <td className="right" colSpan={4}>
                {renderInfo(numberWithComma(item?.total_amount || 0, true))}
              </td>
            </tr>
          )
        })}
    </tbody>
  )

  const hasReturn = detail?.void_items && detail?.void_items.length > 0

  return isLite ? (
    <PdfPrintLiteFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={`ใบแจ้งหนี้/ใบวางบิล`}
      leftInfo={renderCustomerInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={9}
      summaryFooter={summaryFooter}
      signPosition={[`ผู้ออกใบวางบิล`, 'ผู้สั่งซื้อ']}
      thead={tableHeader}
      tbody={tableBody}
      thead2={hasReturn && tableHeader2}
      tbody2={hasReturn && tableBody2}
      moreFooter={moreFooter}
    />
  ) : (
    <PdfPrintFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={`ใบแจ้งหนี้/ใบวางบิล`}
      leftInfo={renderCustomerInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={9}
      summaryFooter={summaryFooter}
      signPosition={[`ผู้ออกใบวางบิล`, 'ผู้สั่งซื้อ']}
      thead={tableHeader}
      tbody={tableBody}
      thead2={hasReturn && tableHeader2}
      tbody2={hasReturn && tableBody2}
      moreFooter={moreFooter}
    />
  )
}

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`
export default BillingNotePDF
